<template>
  <div class="page-applicationFor">
    <div class="applicationFor-search">
      <span class="search-label">企业名称：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="unitName"
        placeholder="请输入内容"
      ></el-input>
      <span class="search-label">联系人姓名：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="contactsName"
        placeholder="请输入内容"
      ></el-input>
      <span class="search-label">联系人手机号：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="contactsPhone"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="applicationFor-add">
      <el-button size="small" type="primary" @click="handleAdd">
        新增
      </el-button>
      <el-button size="small" type="primary" @click="handleIntroduce">
        合作项目介绍
      </el-button>
      <el-button size="small" type="primary" @click="handleExport">
        导出
      </el-button>
    </div>
    <div class="applicationFor-table">
      <el-table
        :data="applicationForList"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ transitionRow(item.prop, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="70"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="applicationFor-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <IntroduceDialog
      v-if="introduceDialogFlag"
      :handleClose="handleCloseIntroduceDialog"
    />
    <WriteDialog
      v-if="writeDialogFlag"
      :dialogTitle="writeDialogTitle"
      :handleClose="handleCloseWriteDialog"
      :defaultData="writeDialogData"
    />
    <FileExport ref="FileExport" />
  </div>
</template>
<script>
import FileExport from '../../components/FileExport.vue'
import { column, intendList } from './assets'
import IntroduceDialog from './introduceDialog.vue'
import WriteDialog from './writeDialog.vue'
import * as API from '../../api/application/index'
export default {
  name: 'ApplicationFor',
  components: { IntroduceDialog, WriteDialog, FileExport },
  data() {
    return {
      unitName: '',
      contactsName: '',
      contactsPhone: '',
      applicationForList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      column,
      introduceDialogFlag: false,
      writeDialogFlag: false,
      writeDialogTitle: '',
      writeDialogData: {}
    }
  },
  created() {
    this.getApplicationForList()
  },
  methods: {
    async getApplicationForList() {
      this.loading = true
      try {
        const { limit, page, contactsName, contactsPhone, unitName } = this
        const params = {
          limit,
          page,
          contactsName,
          contactsPhone,
          unitName
        }
        const res = await API.getApplicationForList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.total = Number(total)
          this.applicationForList = records.map((item, ind) => ({
            ...item,
            sortNum: (page - 1) * limit + ind + 1
          }))
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.getApplicationForList()
    },
    // 重置
    handleReset() {
      this.page = 1
      this.limit = 10
      this.unitName = ''
      this.contactsName = ''
      this.contactsPhone = ''
      this.getApplicationForList()
    },
    // 新增合作申请
    handleAdd() {
      this.writeDialogTitle = '新增合作申请'
      this.writeDialogData = {}
      this.writeDialogFlag = true
    },
    // 合作项目介绍
    handleIntroduce() {
      this.introduceDialogFlag = true
    },
    // 点击详情
    handleDetail(row) {
      this.writeDialogTitle = '合作申请详情'
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getApplicationForList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getApplicationForList()
    },
    handleCloseIntroduceDialog(projectContent) {
      console.log(projectContent)
      if (projectContent && projectContent !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.introduceDialogFlag = false
        }).catch(() => {});
      } else {
        this.introduceDialogFlag = false
      }
    },
    handleExport() {
      const { contactsName, contactsPhone, unitName } = this
      const params = { contactsName, contactsPhone, unitName }
      this.$refs.FileExport.init(
        params, // 搜索表单参数
        'jsw-radioweb-provider', // 后端对应业务线服务
        '/adm/order/testDown', // 导出-对应的接口
        1, //  状态：0get、1post
        '合作申请.xlsx' //文件名称
      )
    },
    // 新建、编辑弹框关闭
    handleCloseWriteDialog(bool) {
      this.writeDialogFlag = false
      switch (bool) {
        case 'reset':
          this.handleReset()
          break
        case 'update':
          this.getApplicationForList()
          break
        default:
          break
      }
    },
    transitionRow(key, row) {
      switch (key) {
        case 'cooperateDesire':
          return row[key]
            ?.split(',')
            .map((ele) => {
              const { label } =
                intendList.find((sub) => sub.value === ele) ?? {}
              return label === '其他'
                ? `【${label}】：${row['otherDesire'] ?? ''}`
                : label
            })
            .filter(Boolean)
            .toString()
        default:
          return row[key]
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.page-applicationFor {
  background: #fff;
  padding: 20px;
  .applicationFor-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 20px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .applicationFor-add {
    margin-bottom: 20px;
  }
  .applicationFor-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>